import React from 'react';
import { useTranslate } from 'app/translations';
import { selfKey } from 'utilities/names';

const Style = {
    container: 'flex flex-wrap w-full',
};

export const Due = ({ historyData, isSelf }) => {
    const { _t } = useTranslate();
    const { before, after } = historyData;

    const date = (date) => {
        const formattedDate = new Date(date);
        return(
            <span className="text-primary-700">
                {formattedDate.toLocaleDateString()}
            </span>
        )
    }
    
    const formatContent = () => {
        if(!before){
            return(
                <div>
                    {_t(selfKey('ticket.history.event.due_date.set', isSelf)).toLowerCase()} {date(after)}
                </div>
            )
        }
        if(!after){
            return(
                <div>
                    {_t(selfKey('ticket.history.event.due_date.removed', isSelf)).toLowerCase()}  {date(before)}
                </div>
            )
        }
        if(before && after){
            return(
                <div>
                    {_t(selfKey('ticket.history.event.due_date.changed', isSelf)).toLowerCase()}  {date(before)} {_t('to').toLowerCase()}  {date(after)}
                </div>
            )
        }
    }

    return (
        <div className={Style.container}>
            {formatContent()}
        </div>
    );
};
